import { Paper, styled } from '@mui/material';
import Link from 'components/Link';

export const PoliciesItemWrap = styled(Paper)(({ theme }) => ({
	position: 'relative',
	zIndex: 2,
	display: 'flex',
	alignItems: 'center',
	gap: '24px',
	borderRadius: '20px',
	overflow: 'hidden',
	transition: 'all .3s',
	backgroundColor: 'white',

	'&:hover': {
		boxShadow: '0px 0px 30px 0px #827D8380',
		'& h2': {
			color: theme.palette.primary.main,
		},
		'& svg': {
			fill: theme.palette.primary.main,
		},
	},

	padding: '8px',
}));

export const PoliciesItemImage = styled('img')(() => ({
	width: '218px',
	height: '310px',
	objectFit: 'contain',
	objectPosition: 'center',

	borderRadius: '10px',
}));

export const PolicyTitle = styled('h2')({
	fontWeight: '600',
	fontSize: '18px',
	lineHeight: '160%',
	letterSpacing: '0.15px',
	color: '#333333',
});

export const PoliciesItemLink = styled(Link)({
	color: 'transparent',
	textDecoration: 'none',
	width: '100%',
});
